import Auction from "./platform";
async function getUserID(){
   const hash = window.location.hash;
   if(hash.split("?")[1]){
    const params = hash.split("?")[1].split("&");
    let tokenId = '';
    params.forEach(item=>{
        const arr=item.split("=");
        if(arr.indexOf("token")>-1){
            tokenId = arr[1];
        }
    })
    const uid = await Auction.GetAuthPower(tokenId);
    if(uid.code == '200'){
         return uid.data.userId;
    }
   }
}


export default  getUserID;


// WEBPACK FOOTER //
// ./src/assets/js/bury.js